import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { td } from '../styles.js';

var _excluded = ["children", "size", "tdHeight", "tdWidth", "highlightColor", "numeric"],
  _excluded2 = ["height", "width"];
var Td = function Td(_ref) {
  var children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === undefined ? 'medium' : _ref$size,
    tdHeight = _ref.tdHeight,
    tdWidth = _ref.tdWidth,
    highlightColor = _ref.highlightColor,
    numeric = _ref.numeric,
    props = _objectWithoutProperties(_ref, _excluded);
  var height = props.height,
    width = props.width,
    rest = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/React.createElement(td, _extends({
    width: tdWidth,
    height: tdHeight,
    $heightCssProp: height,
    $widthCssProp: width,
    $size: size,
    $highlightColor: highlightColor,
    $numeric: numeric
  }, rest), children);
};

export { Td };
